import getFeatureFlagsQuery from './getFeatureFlagsQuery';
import { listUserProfileQuery } from './listUserProfileQuery';
import { getConfigurableRolesQuery } from './roles/getConfigurableRolesQuery';
import { pagedListManagementUsersQuery } from './users/pagedListManagementUsersQuery';

export const CommonAuthorizationService = {
  getFeatureFlagsQuery,
  getConfigurableRolesQuery,
  listUserProfileQuery,
  pagedListManagementUsersQuery,
};
